<template>
  <empty-layout>
    <BackButton variant="floating" :is-gic="isGICConfType" class="z-50" @click="back" />
    <iframe
      :src="src"
      :key="iframeKey"
      title="Strong Church Summit Survey"
      @load="load"
      style="height: 100vh; width: 100vw"
    ></iframe>
  </empty-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import EmptyLayout from '@/components/EmptyLayout.vue';
import BackButton from '@/components/common/BackButton.vue';
import platformMixin from '@/mixins/platformMixin';
import { getCurrentConferenceType } from '@/utils/conference-type';

export default {
  layout: 'form-empty',
  mixins: [platformMixin],
  components: {
    EmptyLayout,
    BackButton,
  },
  data() {
    return {
      surveyId: '',
      iframeKey: 0,
    };
  },
  computed: {
    ...mapGetters('profile', ['delegateId']),
    ...mapState('profile', [
      'name',
      'organization',
      'email',
      'country',
      'groupName',
      'preferredName',
      'confYear',
      'conferences',
    ]),
    isGICConfType() {
      return getCurrentConferenceType(this.confYear, this.conferences) === 'GIC';
    },
    encodedEmail() {
      return encodeURIComponent(this.email);
    },
    encodedName() {
      if (!this.name) return '';
      return encodeURIComponent(this.name);
    },
    encodedOrganization() {
      if (!this.organization) return '';
      return encodeURIComponent(this.organization);
    },
    encodedCountry() {
      if (!this.country) return '';
      return encodeURIComponent(this.country);
    },
    encodedGroupName() {
      if (!this.groupName) return '';
      return encodeURIComponent(this.groupName);
    },
    encodedPreferredName() {
      if (!this.preferredName) return '';
      return encodeURIComponent(this.preferredName);
    },
    src() {
      const url = `https://${this.surveyId}.paperform.co?login=true&id=${this.delegateId}&name=${this.encodedName}&organization=${this.encodedOrganization}&email=${this.encodedEmail}&country=${this.encodedCountry}&teamId=${this.encodedGroupName}&preferredName=${this.encodedPreferredName}`;
      return url;
    },
  },
  ionViewWillEnter() {
    this.surveyId = this.$route.params.name;
    this.iframeKey = this.iframeKey + 1;
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
